import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Star } from 'lucide-react';
import testimonials from './testimonials';

const CustomerRatings = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F6F8F4] py-10 px-4">
      <div className="max-w-6xl mx-auto">

        {/* Back */}
        <motion.button
          onClick={() => navigate('/')}
          whileHover={{ x: -3 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-2 mb-8 px-5 py-3 rounded-xl bg-white border border-[#DDE8DF] text-[#102018] font-semibold hover:border-[#2F6F45] hover:text-[#2F6F45] transition-all duration-300"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </motion.button>

        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-[#EAF5EC] text-[#2F6F45] text-sm font-semibold mb-4">
            CUSTOMER RATINGS
          </span>

          <h1 className="text-3xl md:text-5xl font-heading font-bold text-[#102018] mb-4">
            All Customer <span className="bg-gradient-to-r from-[#2F6F45] to-[#70BD7D] bg-clip-text text-transparent">Reviews</span>
          </h1>

          <p className="text-[#3F4D45]">
            Real feedback from our customers
          </p>
        </div>

        {/* Rating Summary */}
        <div className="bg-white rounded-2xl border border-[#DDE8DF] p-6 md:p-8 mb-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="text-center min-w-[120px]">
              <div className="text-5xl font-bold text-[#102018]">4.4</div>
              <div className="flex justify-center mt-2">
                {[1, 2, 3, 4, 5].map((item) => (
                  <Star
                    key={item}
                    className="w-5 h-5 text-[#2F6F45] fill-current"
                  />
                ))}
              </div>
            </div>

            <div className="w-full space-y-2">
              {[
                { star: 5, percent: 90 },
                { star: 4, percent: 7 },
                { star: 3, percent: 0 },
                { star: 2, percent: 3 },
                { star: 1, percent: 0 }
              ].map((item) => (
                <div key={item.star} className="flex items-center gap-3">
                  <span className="w-4 text-sm font-medium text-[#3F4D45]">
                    {item.star}
                  </span>
                  <div className="flex-1 h-3 rounded-full bg-[#E5E9E6] overflow-hidden">
                    <div
                      className="h-full rounded-full bg-[#2F6F45]"
                      style={{ width: `${item.percent}%` }}
                    />
                  </div>
                  <span className="w-10 text-right text-sm text-[#718078]">
                    {item.percent}%
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* All Ratings */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl border border-[#DDE8DF] p-6 hover:border-[#70BD7D] hover:shadow-[0_18px_40px_rgba(16,32,24,0.08)] transition-all duration-300"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.35,
                delay: Math.min(index * 0.03, 0.35)
              }}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star
                      key={star}
                      className={`w-4 h-4 mr-1 ${
                        star <= testimonial.rating
                          ? 'text-[#2F6F45] fill-current'
                          : 'text-[#DDE8DF]'
                      }`}
                    />
                  ))}
                </div>

                <span className="text-sm font-semibold text-[#2F6F45]">
                  {testimonial.rating}.0
                </span>
              </div>

              <p className="text-[#3F4D45] leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              <div className="flex items-center pt-4 border-t border-[#DDE8DF]">
                <div className="w-10 h-10 rounded-xl bg-[#EAF5EC] flex items-center justify-center text-[#2F6F45] font-bold">
                  {testimonial.name.charAt(0)}
                </div>

                <div className="ml-3">
                  <p className="font-semibold text-[#102018]">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-[#3F4D45]">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Back */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#2F6F45] text-white font-semibold hover:bg-[#102018] transition-all duration-300"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </button>
        </div>

      </div>
    </div>
  );
};

export default CustomerRatings;
